<template>
    <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="chat-modal"
        aria-hidden="true"
        :id="id"
    >
        <div
            class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
            role="document"
        >
            <div class="modal-content" >
                <div class="modal-header">
                    <h4 class="modal-title text-align-center">
                        Search For Client
                    </h4>
                    <button @click="closeModal(`#${id}`)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Search For A Client By Phone or Name"
                            v-model="messageStore.client"
                            @keyup="debouncedSearchClient"
                        />
                    </div>
                </div>
                <h3 class="ml-2"  v-if="messageStore.clients.length > 0">Clients</h3>
                <div class="list-group mr-2 ml-2" v-if="messageStore.clients.length > 0" style="max-height: 200px;overflow: auto;">
                    <a href="#" class="list-group-item list-group-item-action"  v-for="client in messageStore.clients" :key="client.id" @click="messageStore.startMessaging(client.id,user,false)">
                        {{client.full_name}}
                    </a>
                  </div>
                <div class="modal-footer">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                        <!-- <button  class="btn btn-primary mr-sm-1 mb-1 mb-sm-0">
                            Update Chat
                        </button> -->
                        <button @click="closeModal(`#${id}`)" type="button" data-dismiss="modal" class="btn btn-outline-primary" id="close_client_model">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref } from 'vue'
    import { useMessageStore } from '../../stores/MessageStore.js'
    import { closeModal, debounce, hideModal } from '../../utilities/_helpers'
export default{
    name:'Compose Message',
    props:{
        id:{
            type:String
        },
        user:{
            type:[Array,Object]
        }
    },
    components:{
    },
    setup(props){
        return{
            messageStore:useMessageStore(),
            closeModal:closeModal,
            hideModal:hideModal,
            debounce:debounce,
            user:props.user
        }
    },

    mounted(){

    },
    computed: {
        debouncedSearchClient() {
            return debounce(this.messageStore.searchClient, 1000);
        },
    },
    methods:{

    }
}
</script>
